/* assets/glg-surveying-spatial-data-polish.js — GLG-SURVEYING-SPATIAL-DATA-POLISH-RUNTIME-02
 * Motion-only progressive enhancement for /collections/infrastructure-engineering.
 * Owns workflow in-view reveal state only. No route, filter, product, checkout, API or project-state mutation.
 */
(function (window, document) {
  'use strict';

  var PAGE_SELECTOR = '[data-collection-hero][data-collection-family="surveying-spatial"]';
  var WORKFLOW_ROOT = '#collection-workflows';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function workflowItems(root) {
    var grid = root && root.querySelector('[data-collection-workflow-grid]');
    if (!grid) return [];
    return Array.prototype.filter.call(grid.children, function (node) {
      return node.classList && node.classList.contains('mcpg__item') && node.querySelector('[data-survey-workflow-card]');
    });
  }

  function revealImmediately(root, items) {
    root.classList.add('is-surveying-inview-ready');
    items.forEach(function (item) {
      item.setAttribute('data-survey-inview-card', '');
      item.classList.add('is-in-view');
    });
  }

  function setupWorkflowInView() {
    if (!document.querySelector(PAGE_SELECTOR)) return;
    var root = document.querySelector(WORKFLOW_ROOT);
    if (!root || root.dataset.surveyInViewReady === 'true') return;

    var items = workflowItems(root);
    if (!items.length) return;
    root.dataset.surveyInViewReady = 'true';

    if (prefersReducedMotion() || typeof window.IntersectionObserver !== 'function') {
      revealImmediately(root, items);
      return;
    }

    items.forEach(function (item, index) {
      item.setAttribute('data-survey-inview-card', '');
      item.style.setProperty('--survey-inview-delay', ((index % 4) * 40) + 'ms');
    });
    root.classList.add('is-surveying-inview-ready');

    let observer;
    try {
      observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in-view');
          observer.unobserve(entry.target);
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      items.forEach(function (item) { observer.observe(item); });
      root.__surveyInViewObserver = observer;
    } catch (_error) {
      if (observer) observer.disconnect();
      revealImmediately(root, items);
    }
  }

  function boot() {
    if (!document.querySelector(PAGE_SELECTOR)) return;
    if (window.requestAnimationFrame) window.requestAnimationFrame(setupWorkflowInView);
    else setupWorkflowInView();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event && event.target && event.target.querySelector ? event.target.querySelector(WORKFLOW_ROOT) : null;
    if (root && root.__surveyInViewObserver) root.__surveyInViewObserver.disconnect();
  });
})(window, document);
